// @ts-nocheck
import KioskHealthCard from "./KioskHealthCard";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type Props = {
  data: any;
};

const KioskHealthContainer = ({ data }: Props) => {
  return (
    <div>
      {data.map(
        (
          venue: { kiosks: any[]; venueName: string; venueId: number },
          i: any
        ) => (
          <Accordion key={`venue-${i}`} sx={{ borderRadius: 2, mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ flexGrow: 1 }}>
                {venue.venueName} (ID: {venue.venueId})
              </Typography>
              <Chip label={`Kiosks: ${venue.kiosks.length}`} size="small" />
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {venue.kiosks.map((kiosk, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={`kiosk-${index}`}
                  >
                    <KioskHealthCard kiosk={kiosk} />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        )
      )}
    </div>
  );
};

export default KioskHealthContainer;
